import { Box, FormControl, InputLabel, MenuItem, Select, SelectChangeEvent } from "@mui/material";
import { useEffect } from "react";
import { Utils } from "../constants/utilities.constants";
import { useTranslation } from "../../i18n/useTranslation";
import React from "react";

export interface ISearchableDropdownParam {
  data: any[];
  handleChange: Function;
  defaultValue: string;
  propName: string;
  outlinedLabelName: string;
  translateCode: string;
}

const SearchableDropdown: React.FC<ISearchableDropdownParam> = ({data, defaultValue, propName, handleChange, outlinedLabelName, translateCode}): JSX.Element => {
  const { t } = useTranslation('translation');
  const [selectedValue, setSelectedValue] = React.useState(defaultValue);

  useEffect(() => {
    if (!Utils.isNullOrUndefined(defaultValue)) {
      setSelectedValue(defaultValue);
    }
  }, []);

  const onChange = (event: SelectChangeEvent) => {
    handleChange(event.target.value);
    setSelectedValue(event.target.value);
  };
  return (
    <>
    <Box sx={{ minWidth: 150 }}>
      <FormControl fullWidth>
        <InputLabel>{t(outlinedLabelName)}</InputLabel>
        <Select
          value={selectedValue}
          label={t(outlinedLabelName)}
          size="small"
          onChange={onChange}
        >
          {data.map((item) => (
            <MenuItem
              key={item[propName]}
              value={item[propName]}
            >
              {t(`${translateCode}.` + item[propName])}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
      </>
  );
};

export default SearchableDropdown;
